// ** Dayjs plugin to determine the current week of a dates month
const weekOfMonthPlugin = (_option, dayjsClass, _dayjsFactory) => {
  // eslint-disable-next-line no-param-reassign
  dayjsClass.prototype.weekOfMonth = function () {
    return Math.ceil(this.date() / 7);
  };
};

export default weekOfMonthPlugin;
